import React from 'react'

const Footer = () => {
  return (
    <div className="uk-section uk-section-small trip-background-black trip-white">
    <div className="uk-container uk-container-small uk-margin-auto">

    <div className='uk-text-center'>
        <div>

        </div>
        <div className='uk-text-small'> All statistics and data are sourced from Tripadvisor internal data as of November 1, 2022 <br className="uk-visible@m"/> and do not account for any changes or cancellations. </div>
        <br/>
      <span className='uk-text-medium'> &copy; 2022 Tripadvisor LLC. All rights reserved.</span> 

    </div>

    </div>
</div>
  )
}

export default Footer